import React from 'react';
import { TrophyOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { trackEvent } from '../../utils/analytics';
import { BENCHMARK_LABEL as CLAIM_LABEL, BENCHMARK_URL as CLAIM_URL } from '../../content/benchmarkClaim';
import './BenchmarkBadge.css';

/**
 * BenchmarkBadge — the shared, always-visible deep-research proof point that
 * appears on every marketing hero (AI Employees, Super-Agents, Agent-to-Agent).
 *
 * The claim wording and link come from ONE source: src/content/benchmarkClaim.json
 * (Oct 21 2026 ruling; text homes that cannot import it are guarded by
 * marketing/scripts/check_benchmark_claim.py --verify). It's a real crawlable
 * <a> (not an image) linking to the live leaderboard, so it serves trust AND
 * gives a semantic, authority outbound link.
 *
 * Wording is the dated label from benchmarkClaim.json, ALWAYS date-stamped
 * (the live board churns, so the claim carries its verified month; never ship
 * the undated form). To change the claim, edit benchmarkClaim.json, never here.
 * The two exports below are kept so existing importers do not change.
 *
 * Analytics (Aug 16, CEL-1287): every usage now passes `page`, so clicks fire
 * a cta_click carrying BOTH `page` (the preferred identity axis going forward)
 * and `compare_page` (legacy axis, kept until the CEL-1096 migration).
 * Optional `location` defaults to 'hero' (non-hero usages override it).
 */
export const BENCHMARK_LABEL = CLAIM_LABEL;
export const BENCHMARK_URL = CLAIM_URL;

const BenchmarkBadge = ({ page, location = 'hero' }) => (
  <a
    className="mkt-bench-badge"
    href={BENCHMARK_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={
      page
        ? () => trackEvent('cta_click', { cta_name: 'benchmark_badge', page, compare_page: page, location })
        : undefined
    }
  >
    <TrophyOutlined className="mkt-bench-badge__icon" />
    <span className="mkt-bench-badge__label">{BENCHMARK_LABEL}</span>
    <ArrowRightOutlined className="mkt-bench-badge__arrow" />
  </a>
);

export default BenchmarkBadge;
